module.exports = __webpack_public_path__ + "img/businessModel2.2aed6c5c.png";